mpangoApp.factory('Mreports',['$http', function($http) {
	return{
		toExcel : function(tempname,xtype,id,field_name) {
			return $http({
				method: 'GET',
				url: 'index.php/api/toexcel',
				headers: { 'Content-Type' : 'application/x-www-form-urlencoded' },
				params: {'data':tempname,'xtype':xtype,'eId':id,'limit':field_name}
			
			});
		},
		getActlog : function() {
			return $http({
				method: 'GET',
				url: 'index.php/api/getactlogs',
				headers: { 'Content-Type' : 'application/x-www-form-urlencoded' },
						
			});
		},
		getAllsms : function() {
			return $http({
				method: 'GET',
				url: 'index.php/api/smslist',
				headers: { 'Content-Type' : 'application/x-www-form-urlencoded' },
			});
		},
		downloadManual : function(fname) {
			return $http({
				method: 'GET',
				url: 'index.php/api/downloadmanual',
				params: {'data':fname}
			});
		},
	}
}]);